import { React, useLayoutEffect, useRef, useState } from 'react'
import { useAppContext } from '../../AppProvider';
import "../services/Services.css"
import GCMarqueeText from "../../GCMarqueeText"
import GC_Service_Cat from '../../GC_Service_Cat';
import GC_Process from '../../GC_Process';
import GC_FAQ from '../../GC_FAQ';
import { Helmet } from 'react-helmet-async';



import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from "gsap";
import $ from 'jquery';

gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);


const MarketingCollateral = (prop) => {

    const { gpageTransition, openCalender, openCalendly } = useAppContext();
    const marqueeText = "Marketing Collateral"
    const processSteps = [
        {
            "title": "Requirement Discovery",
            "desc": ["Brand identity analysis.", "Target audience understanding.", "Competitor collateral review.", "Use-case definition.", "Content requirements."]
        },
        {
            "title": "Concept & Direction",
            "desc": ["Content hierarchy planning.", "Key message refinement.", "Copy alignment with brand tone.", "CTA placement strategy.", "Information flow optimization."]
        },
        {
            "title": "Content Creation",
            "desc": ["Mood boards and visual direction.", "Layout style exploration.", "Typography and color alignment.", "Brand consistency guidelines.", "Concept variations for approval."]
        },
        {
            "title": "Design Creation",
            "desc": ["Brochures, flyers and posters.", "Business cards and stationery.", "Pitch decks and presentations.", "Social media marketing assets.", "Digital ads creatives and banners."]
        },
        {
            "title": "Finalization Delivery",
            "desc": ["Print-ready files.", "Digital optimized versions", "Editable source files", "Format variations.", "Organized asset delivery."]
        },
        {
            "title": "Brand Usage",
            "desc": ["Guidelines and recommendations.", "File organization system.", "Print vendor instructions (if required).", "Scaling suggestions.", "Ongoing design support."]
        }
    ];


    const subServices =
        [
            {
                "title": "Brand Identity Collateral",
                "desc": `Core brand assets that define how your business is visually represented across all touchpoints.`,
                "imageURL": "/assets/img/services/marketing-collateral/brand-identity-collateral.webp",
                "accordian":
                    [
                        {
                            "title": "What’s Included",
                            "desc": ["Business card design", "Letterheads & stationery", "Envelopes & corporate templates", "Brand profile documents", "Email signature design"]
                        }
                        ,
                        {
                            "title": "Deliverables",
                            "desc": ["Print-ready brand stationery kit", "Editable source files", "Brand-consistent templates", "Digital + print formats"]
                        },
                        {
                            "title": "Ideal for",
                            "desc": ["Startups building identity", "Corporate businesses", "Professional service providers"]
                        }

                    ]
            },


            {
                "title": "Corporate Collateral",
                "desc": `Corporate collateral is more than just design—it’s how your business communicates credibility, consistency, and professionalism across every touchpoint. We create strategic, visually compelling corporate materials that strengthen your brand identity and ensure your message is clear, cohesive, and impactful. From internal documents to client-facing assets, everything we design is built to reflect your business at its best.`,
                "imageURL": "/assets/img/services/marketing-collateral/corporate-collateral.webp",
                "accordian":
                    [
                        {
                            "title": "What’s Included",
                            "desc": ["Company profiles & capability statements", "Letterheads, envelopes & email signatures", "Corporate brochures & flyers", "Brand guidelines documentation"]
                        }
                        ,
                        {
                            "title": "Deliverables",
                            "desc": ["Editable source files (Figma / Adobe / PPT / Canva as required)", "High-resolution print-ready PDFs", "Digital versions optimized for sharing and presentations", "Typography, color, and style consistency across all materials"]
                        },
                        {
                            "title": "Ideal for",
                            "desc": ["Corporate companies & enterprises", "Startups preparing for investors or funding rounds", "Marketing and sales teams", "Consulting firms & agencies", "B2B service providers", "Organizations undergoing rebranding or scaling"]
                        }

                    ]
            },


            // {
            //     "title": "Email Marketing Automation",
            //     "desc": "We design and automate high-converting email campaigns that nurture leads, retain customers, and increase lifetime value.",
            //     "imageURL": "/assets/img/services/marketing-collateral/email-marketing-automation.webp",
            //     "accordian": 
            //     [
            //         {
            //             "title": "What’s Included",
            //             "desc": ["Email template design", "Automation workflow setup", "Audience segmentation", "Campaign scheduling", "A/B testing", "Performance analytics" ]
            //         },
            //          {
            //             "title": "Solutions",
            //             "desc": ["Lead nurturing sequences", "Welcome email series", "Abandoned cart emails", "Promotional campaigns", "Customer retention flows"]
            //          },
            //          {
            //             "title": "Ideal for",
            //             "desc": ["Businesses wanting consistent", "Automated customer communication", "Higher conversions"]
            //         }
            //     ]    
            // },
            {
                "title": "Print Marketing Materials",
                "desc": "Professionally designed print assets that strengthen offline brand presence and marketing efforts.",
                "imageURL": "/assets/img/services/marketing-collateral/print-marketing-materials.webp",
                "accordian":
                    [
                        {
                            "title": "What’s Included",
                            "desc": ["Brochures & flyers", "Posters & banners", "Catalog & product sheets", "Packaging inserts", "Event & exhibition materials"]
                        },
                        {
                            "title": "Deliverables",
                            "desc": ["Print-ready high-resolution files", "CMYK color-optimized designs", "Vendor-ready artwork files", "Layout variations if needed"]
                        },
                        {
                            "title": "Ideal for ",
                            "desc": ["Retail businesses", "Events & exhibitions", "Product-based companies", "Corporate marketing teams"]
                        }
                    ]
            },

            {
                "title": "Product & Packaging Design",
                "desc": "Visual packaging and product presentation designs that enhance perceived value and brand recognition.",
                "imageURL": "/assets/img/services/marketing-collateral/product-packaging-design.webp",
                "accordian":
                    [
                        {
                            "title": "What’s Included",
                            "desc": ["Product packaging design", "Label design", "Box & container layouts", "Retail packaging concepts", "Brand packaging systems"]
                        },
                        {
                            "title": "Deliverables",
                            "desc": ["Print-ready packaging files", "3D mockups", "Packaging design system", "Manufacturer-ready artwork"]
                        },
                        {
                            "title": "Ideal for ",
                            "desc": ["FMCG brands", "E-commerce products", "Retail businesses", "Lifestyle brands"]
                        }
                    ]
            },



            // {
            //     "title": "Content Marketing Assets",
            //     "desc": "We produce high-quality visual and written content that educates, engages, and positions your brand as an industry authority.",
            //     "imageURL": "/assets/img/services/branding/brand-identity-design.webp",
            //     "accordian": 
            //     [
            //         {
            //             "title": "What’s included",
            //             "desc": ["Blog graphics", "Infographics", "Lead magnets", "Visual content design", "Content formatting", "Brand consistency checks"]
            //         },
            //         {
            //             "title": "Benefits",
            //             "desc": ["Educational content", "Thought leadership assets", "Downloadable resources", "Website content visuals", "Campaign content packages"]
            //         },                  
            //         {
            //             "title": "Ideal for",
            //             "desc": ["Brands focused on long-term growth through valuable, consistent content marketing."]
            //         }
            //     ]    
            // },

        ]

    const faq =
        [
            {
                "question": "What are marketing collateral services?",
                "answer": "Marketing collateral services include the design and creation of branded materials used to promote your products, services, and campaigns across digital and print channels."
            },
            {
                "question": "What types of collateral do you design?",
                "answer": "We design social media creatives, email templates, ad banners, brochures, company profiles, pitch decks, infographics, and other branded marketing assets."
            },
            {
                "question": "Do you follow our brand guidelines?",
                "answer": "Yes, we strictly follow your existing brand guidelines. If needed, we can also help refine or create brand standards for consistency."
            },
            {
                "question": "Can you create content as well as design?",
                "answer": "Absolutely. We provide both copywriting and visual design to ensure your marketing materials are clear, engaging, and conversion-focused."
            },
            {
                "question": "Will the designs be optimized for different platforms?",
                "answer": "Yes, all assets are tailored and resized for the specific platforms where they will be used, ensuring best performance and visual quality."
            },
            {
                "question": "How many revisions are included?",
                "answer": "We typically include multiple revision rounds to ensure the final collateral meets your expectations. Exact numbers can be defined per project."
            },
            {
                "question": "How long does it take to deliver marketing collateral?",
                "answer": "Timelines depend on project scope, but most standard assets are delivered within a few business days after requirements and approvals."
            },
            {
                "question": "Can you handle ongoing marketing collateral needs?",
                "answer": "Yes, we offer ongoing design support for businesses that require regular marketing materials and campaign creatives."
            },
            {
                "question": "What file formats will we receive?",
                "answer": "You will receive web-ready and print-ready files in formats such as JPG, PNG, PDF, and source files when included in the scope."
            },
            {
                "question": "How do we get started?",
                "answer": "Simply share your requirements, brand assets, and objectives. We’ll review, propose a plan, and begin the creative process quickly."
            }
        ]



    const sectionProcessRef = useRef(null);
    const [imageCount, setImageCount] = useState(0);

    // Scroll Trigger For WORK Section
    useLayoutEffect(() => {




        // PROCESS
        {
            let totalPlanets = processSteps.length;
            let planetArr = Array.from({ length: totalPlanets }, (_, i) => i * 360 / totalPlanets);

            function degreeToRadian(radians) {
                return radians * (Math.PI / 180);
            }
            function getScrollAmountProcess() {
                return -(2000);
            }


            const tlProcessInit = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionProcessRef.current,
                    pin: false,
                    start: 'top 90%',
                    end: "top 5%",

                    scrub: 1,
                    ease: 'none',
                    markers: false,

                    onUpdate: (self) => {
                        $('.planet').each(function () {
                            $(this).css("opacity", 1);
                        });



                        $('#galaxyPath').css("stroke-dashoffset", (-2100 * self.progress - 2100));
                        let r = (Math.floor($('.solar-system').width() - 12) / 2);

                        for (let i = 0; i < planetArr.length; i++) {
                            let degF = -90 + (planetArr[i] * self.progress);
                            let degFPer = degreeToRadian(degF);
                            $('.planet-' + (i + 1)).css("left", (Math.cos(degFPer) * (r)) + (r - 4) + "px");
                            $('.planet-' + (i + 1)).css("top", (Math.sin(degFPer) * (r)) + (r - 4) + "px");
                        }

                    }

                },
            });

            const tlProcess = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionProcessRef.current,
                    pin: true,
                    start: 'top 8.2%',

                    end: () => `+=${getScrollAmountProcess() * -1}`,
                    scrub: 1,
                    ease: 'none',
                    markers: false,

                    onUpdate: (self) => {
                        let progress = self.progress

                        $('#galaxyPathActive').css("stroke-dashoffset", (-2100 * progress - 2100));

                        let diff = 1 / planetArr.length;
                        for (let i = 0; i < planetArr.length; i++) {
                            $('.planet-' + (i + 1)).removeClass('active');
                            $('.planet-desc' + (i + 1)).removeClass('active');



                            if (progress >= (diff * i) - .01) {


                                $('.solar-system .heading').addClass("active");
                                $('.solar-system .content').css("transform", "translateY(" + (- 1.11 * i) + "em)");
                                $('.planet-' + (i + 1)).addClass('active');

                                $('.solar-system .details div').each(function (e) {
                                    console.log("1")
                                    $(this).removeClass('active')

                                });

                                $('.planet-desc-' + (i + 1)).addClass('active');
                            }

                            if (progress == 0) {
                                $('.planet-1').removeClass('active')
                                $('.planet-desc-1').removeClass('active')

                                $('.solar-system .heading').removeClass("active");
                                $('.solar-system .content').css("transform", "translateY(1.1em)");
                            }
                        }


                    }
                },
            }, [imageCount]);
        }

        // Why Choose Us
        {



            const tlWhyChooseUs = gsap.timeline({
                scrollTrigger: {
                    trigger: '.page-services.why-choose-us .hh2 ',
                    start: 'top 70%',
                    end: 'bottom 70%',
                    scrub: 1,
                    markers: false,
                    ease: 'none',
                },
            });

            tlWhyChooseUs.fromTo('.page-services.why-choose-us .hh2 div',
                {
                    opacity: 0,
                    y: 100
                },
                {
                    opacity: 1,
                    y: 0,
                    stagger: .05

                });


            const whyChooseUsObj = document.querySelectorAll('.why-choose-us .card ');

            whyChooseUsObj.forEach((item, i) => {

                gsap.fromTo(item,
                    {
                        opacity: 0,
                        scale: 0,
                        y: 100
                    },
                    {
                        opacity: 1,
                        scale: 1,
                        y: 0,
                        ease: 'none',

                        scrollTrigger:
                        {
                            trigger: item,
                            scrub: 'none',
                            markers: false,
                            start: "top 90%",
                            end: "bottom 90%"
                        }

                    });

            });


        }

        {
            const tlCTA = gsap.timeline({

                scrollTrigger: {
                    trigger: '.page-services.cta-1 .container ',
                    start: 'top 70%',
                    end: 'bottom 70%',
                    scrub: 1,
                    markers: false,

                },
            });

            tlCTA.fromTo('.page-services.cta-1 .items-center .content-wrapper',
                {
                    opacity: 0,
                    y: 100
                },
                {
                    opacity: 1,
                    y: 0,
                    stagger: .08

                });
        }


        // FAQ
        {

            gsap.fromTo('section.faq .hh2',
                {
                    opacity: 0,
                    y: 100
                },
                {
                    scrollTrigger: {
                        trigger: 'section.faq .hh2 ',
                        start: 'top 80%',
                        end: 'bottom 80%',
                        scrub: 1,
                        markers: false,

                    },
                    opacity: 1,
                    y: 0,
                    stagger: .08

                });





            const faqObj = document.querySelectorAll('.faq .accordion .accordion-item');


            faqObj.forEach((item, i) => {

                gsap.fromTo(item,
                    {
                        opacity: 0,

                        y: 100
                    },
                    {
                        opacity: 1,

                        y: 0,
                        ease: 'none',

                        scrollTrigger:
                        {
                            trigger: item,
                            scrub: 'none',
                            markers: false,
                            start: "top 90%",
                            end: "bottom 100%"
                        }

                    });


            });

        }


        return () => {
            ScrollTrigger.killAll();
        };

    });

    const onImgLoad = () => {

        setImageCount(prev => prev + 1);
    };
    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://robustik.com/services/marketing-collateral" />
            </Helmet>
            <section className='page-services hero'>
                <div className='container '>
                    <div className="flex flex-wrap -mx-2">

                        <div className="w-full xl:w-1/2 relative  md:hidden mb-10 px-2 ">
                            <img src="/assets/img/services/marketing-collateral/hero-image.webp" alt={marqueeText} fetchPriority='high' width="100%" height="auto" data-aos="zoom-in" data-aos-delay="100" onLoad={onImgLoad} />
                        </div>


                        <div className="w-full xl:w-1/2 flex justify-center flex-col px-2">
                            <div className="hh1" data-aos="fade-up" data-aos-delay="200">
                                Marketing Collateral That <span className="text-primary font-semibold ">Communicates </span>and <span className="text-primary font-semibold ">Connects </span>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="300">
                                <p>We create impactful marketing collateral that strengthens your brand, delivers clear messaging, and drives meaningful engagement across digital and offline channels. From social media to automated email campaigns, we help your brand stay consistent, visible, and persuasive.</p>
                            </div>

                            <div className='mt-5 '>
                                <button onClick={openCalendly} data-aos="fade-up" data-aos-delay="400">
                                    <div>GET FREE CONSULTATION<i></i></div>
                                </button>
                            </div>
                        </div>

                        <div className="w-full xl:w-1/2 relative hidden sm:block mt-10 mb-10 px-5 text-right">
                            <img src="/assets/img/services/marketing-collateral/hero-image.webp" fetchPriority='high'  alt={marqueeText} data-aos="zoom-in" data-aos-delay="100" onLoad={onImgLoad} width="644px" height="685px" />
                        </div>
                    </div>
                </div>
            </section>

            <div data-aos="fade-up" data-aos-delay="300">
                <GCMarqueeText text={marqueeText} />
            </div>



            <GC_Service_Cat subServices={subServices} onImgLoad={onImgLoad} marqueeText={marqueeText} />

            <GC_Process ref={sectionProcessRef} processSteps={processSteps} />

            <section className="page-services why-choose-us">
                <div className="container">
                    <div className='hh2 text-center'>
                        <div>Why Choose Us for</div>
                        <div className='text-primary hh1'>{marqueeText}</div>
                    </div>


                    <div className='card-wrapper mt-20'>


                        <div className=' flex flex-wrap  -mx-3 '>
                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-5 md:mb-0'>
                                    <svg width="65" height="60" viewBox="0 0 65 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_307_77)">
                                            <path d="M42.7267 38.6791L50.219 9.85898C50.3235 9.45509 50.1833 9.03184 49.8698 8.77733C49.6141 8.46196 49.1935 8.32088 48.7948 8.426L20.1509 15.9644C18.4133 16.3157 17.088 17.6104 16.6921 19.3504C16.3429 20.883 16.7883 22.4156 17.8634 23.4945C18.0201 23.6522 18.1905 23.7988 18.372 23.9371C18.4188 23.9731 18.4682 24.0035 18.5205 24.0311L29.2351 29.539L34.7093 40.3196C34.7368 40.3721 34.767 40.4219 34.8028 40.469C34.9375 40.6516 35.086 40.8231 35.2427 40.9808C36.315 42.0596 37.8409 42.5106 39.3614 42.1592C41.0936 41.7609 42.3803 40.4275 42.7267 38.6791ZM36.5322 39.2739L31.2945 28.9608L47.2194 13.0597L40.6894 38.1756C40.6839 38.1978 40.6784 38.2199 40.6729 38.2448C40.4914 39.1937 39.8261 39.888 38.8912 40.101C37.9812 40.3113 37.1041 40.0042 36.5322 39.2739ZM18.7349 19.8235C18.9494 18.8829 19.6395 18.2134 20.5798 18.0309C20.6018 18.0253 20.6266 18.0198 20.6486 18.0143L45.6109 11.4441L29.807 27.467L19.557 22.197C18.8312 21.6216 18.526 20.7392 18.7349 19.8235Z" fill="#DC0000" />
                                            <path d="M18.4983 30.1505C18.8007 29.8462 18.8007 29.3538 18.4983 29.0495C18.1959 28.7452 17.7065 28.7452 17.404 29.0495L12.4495 34.0345C12.147 34.3388 12.147 34.8312 12.4495 35.1355C12.6007 35.2877 12.7987 35.3624 12.9966 35.3624C13.1946 35.3624 13.3926 35.2877 13.5438 35.1355L18.4983 30.1505Z" fill="#DC0000" />
                                            <path d="M28.8005 40.7077L23.846 45.6927C23.5435 45.997 23.5435 46.4895 23.846 46.7938C23.9972 46.9459 24.1952 47.0206 24.3931 47.0206C24.5911 47.0206 24.789 46.9459 24.9403 46.7938L29.8948 41.8087C30.1972 41.5044 30.1972 41.012 29.8948 40.7077C29.5923 40.4034 29.1029 40.4034 28.8005 40.7077Z" fill="#DC0000" />
                                            <path d="M23.8044 35.1804C23.5019 34.8761 23.0125 34.8761 22.7101 35.1804L13.5901 44.3565C13.2877 44.6608 13.2877 45.1532 13.5901 45.4575C13.7413 45.6096 13.9393 45.6843 14.1373 45.6843C14.3352 45.6843 14.5332 45.6096 14.6844 45.4575L23.8044 36.2814C24.1068 35.9771 24.1068 35.4847 23.8044 35.1804Z" fill="#DC0000" />
                                            <path d="M61.4257 0H3.5743C1.60294 0 0 1.6128 0 3.59629V49.2499C0 51.2333 1.60294 52.8461 3.5743 52.8461H24.8084L30.0104 58.7247C30.7335 59.574 31.6848 60 32.6361 60C33.5874 60 34.5387 59.574 35.2618 58.7247L40.4611 52.8461H61.4229C63.3943 52.8461 64.9972 51.2333 64.9972 49.2499V3.59629C64.9972 1.6128 63.3943 0 61.4229 0H61.4257ZM34.2115 57.4909C33.3427 58.5117 31.9295 58.5117 31.0607 57.4909L26.5818 52.4616L25.4957 51.1863H3.5743C2.51301 51.1863 1.64968 50.3177 1.64968 49.2499V3.59629C1.64968 2.52847 2.51301 1.65983 3.5743 1.65983H61.4257C62.487 1.65983 63.3503 2.52847 63.3503 3.59629V49.2499C63.3503 50.3177 62.487 51.1863 61.4257 51.1863H39.7764L38.3632 52.8461L34.2143 57.4909H34.2115Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_307_77">
                                                <rect width="65" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <div className="mt-10 hh5">Strategic Messaging</div>
                                    <p>Every piece of collateral is designed with a clear purpose aligned to your marketing goals.</p>
                                </div>
                            </div>

                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-5 md:mb-0'>
                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_307_90)">
                                            <path d="M31.9266 53.1767C31.5798 53.1767 31.2841 52.9123 31.2556 52.5626C31.0936 50.7713 29.9989 48.9659 27.9149 48.9659C25.9957 48.9659 24.8698 50.0577 23.6785 51.8205C23.471 52.1304 23.053 52.21 22.7403 52.0053C22.4304 51.7977 22.3507 51.3741 22.5583 51.067C23.7695 49.2758 25.2536 47.6154 27.912 47.6154C30.832 47.6154 32.3872 50.1174 32.5948 52.4431C32.6289 52.8156 32.356 53.1426 31.9835 53.1767C31.9636 53.1767 31.9437 53.1795 31.9238 53.1795L31.9266 53.1767ZM37.8121 51.7579C37.6926 51.7579 37.5704 51.7238 37.4595 51.6556C34.494 49.8416 32.7227 47.0297 32.7227 44.1353C32.7227 43.0919 32.9331 41.9432 33.2857 41.0618C33.4222 40.7121 33.8259 40.5472 34.1614 40.6837C34.5111 40.8202 34.676 41.2125 34.5395 41.5594C34.1955 42.4209 34.0761 43.4558 34.0761 44.1325C34.0761 46.5151 35.6427 48.9574 38.1646 50.5012C38.483 50.6974 38.5854 51.1097 38.3864 51.4281C38.2584 51.6414 38.0367 51.7551 37.8121 51.7551V51.7579ZM18.7456 50.1913C18.5266 50.1913 18.3134 50.0833 18.1826 49.89C17.9751 49.58 18.0604 49.1592 18.3731 48.9545C22.6038 46.1483 26.0242 43.4331 29.4616 40.1435C31.2556 38.4262 34.2666 34.9831 34.2666 31.2272C34.2666 28.9697 32.7455 26.5729 29.9307 26.5729C27.423 26.5729 25.501 29.4587 23.6444 32.2479C22.6521 33.7377 21.7139 35.1451 20.6704 36.1658C17.8244 38.9465 14.8817 40.5984 11.6091 42.3214C11.2793 42.4948 10.8699 42.3669 10.6965 42.0399C10.523 41.7072 10.651 41.3007 10.9808 41.1272C14.1595 39.4526 17.0141 37.8547 19.7293 35.1992C20.6704 34.278 21.5717 32.9274 22.5213 31.5002C24.577 28.4124 26.7008 25.2252 29.9307 25.2252C33.4904 25.2252 35.6199 28.2788 35.6199 31.23C35.6199 35.4892 32.3474 39.2564 30.397 41.1215C26.8999 44.468 23.4226 47.2316 19.1237 50.0833C19.0043 50.1572 18.8764 50.1942 18.7484 50.1942L18.7456 50.1913ZM43.7287 48.4655C43.6463 48.4655 43.561 48.4513 43.4814 48.42C38.4859 46.4582 37.4367 42.418 37.4367 39.3758C37.4367 38.0623 37.6955 36.8368 37.9656 35.5346C38.284 34.0135 38.6138 32.4412 38.6138 30.4482C38.6138 26.8999 35.5944 21.984 29.9222 21.984C25.1371 21.984 22.2399 25.6773 20.9377 27.8779C19.6668 30.0274 16.127 35.2475 10.7022 37.2519C10.3496 37.377 9.96293 37.2064 9.83499 36.8539C9.7042 36.5042 9.88616 36.1147 10.233 35.9867C13.716 34.7016 17.2813 31.4149 19.7748 27.1927C21.222 24.7447 24.4632 20.6363 29.9193 20.6363C35.927 20.6363 39.9615 25.7114 39.9615 30.4482C39.9615 32.5806 39.6004 34.2979 39.2848 35.8104C39.0147 37.0927 38.7844 38.1987 38.7844 39.373C38.7844 41.9972 39.6829 45.4773 43.9733 47.1605C44.3201 47.2941 44.4907 47.6865 44.3542 48.0362C44.2519 48.3034 43.9988 48.4684 43.7287 48.4684V48.4655ZM14.7054 47.2145C14.4779 47.2145 14.2562 47.0979 14.1311 46.8932C13.9349 46.5776 14.0344 46.1597 14.3528 45.9663C19.246 42.9582 25.8194 37.9684 29.3592 31.3182C29.5355 30.9884 29.9392 30.8604 30.2719 31.0396C30.5989 31.2158 30.7268 31.6253 30.5505 31.9522C26.8657 38.8669 20.0904 44.0159 15.0579 47.115C14.9499 47.1832 14.8276 47.2173 14.7054 47.2173V47.2145ZM46.5719 44.8148C46.481 44.8148 46.39 44.7949 46.3018 44.758C42.8928 43.2767 42.2048 41.0704 42.2048 37.9912C42.2048 36.0379 42.4294 35.0598 42.6682 34.0192C42.9184 32.9274 43.1772 31.793 43.1772 29.2483C43.1772 23.5619 38.1106 17.4292 29.925 17.4292C23.7382 17.4292 20.7443 20.5197 18.2025 23.687C17.9239 24.0368 17.6168 24.4433 17.2842 24.8897C15.6834 27.0193 13.497 29.9364 10.7277 31.0595C10.3809 31.1988 9.98852 31.0339 9.8492 30.687C9.70989 30.3401 9.87479 29.9478 10.2217 29.8084C12.6412 28.8275 14.6997 26.0839 16.2037 24.0794C16.5478 23.6245 16.8605 23.2037 17.1477 22.8426C19.8914 19.4194 23.1412 16.0786 29.925 16.0786C38.9465 16.0786 44.5305 22.9137 44.5305 29.2483C44.5305 31.9465 44.2405 33.2089 43.9875 34.3234C43.7657 35.2844 43.5582 36.1943 43.5582 37.994C43.5582 41.1016 44.3542 42.4465 46.842 43.524C47.1861 43.6719 47.3396 44.0699 47.1918 44.414C47.0837 44.6642 46.8364 44.8148 46.5776 44.8148H46.5719ZM47.1861 40.3112C47.0468 40.3112 46.9074 40.2686 46.788 40.1804C46.4866 39.9615 46.4213 39.5379 46.6402 39.2365C47.9708 37.4168 48.7953 34.2382 48.7953 30.94C48.7953 29.1431 48.6532 27.1756 47.6097 24.9494C47.4533 24.6111 47.5955 24.2102 47.9367 24.051C48.2665 23.8946 48.6759 24.0368 48.8351 24.3751C49.9923 26.8458 50.1487 29.0806 50.1487 30.94C50.1487 34.5623 49.2474 37.9627 47.7348 40.0297C47.6012 40.2089 47.3965 40.3084 47.1889 40.3084L47.1861 40.3112ZM11.5665 24.1221C11.4385 24.1221 11.3106 24.0851 11.194 24.0112C10.8841 23.8065 10.796 23.3857 11.0007 23.0758C14.2618 18.1229 19.7748 11.5381 29.9193 11.5381C36.9591 11.5381 43.4757 15.0523 47.3538 20.9377C47.5585 21.2504 47.4732 21.6684 47.1605 21.8731C46.8506 22.0778 46.4298 21.9953 46.2251 21.6797C42.6 16.1725 36.5042 12.8886 29.9193 12.8886C20.4259 12.8886 15.22 19.1294 12.1266 23.8207C11.9987 24.0169 11.7826 24.1221 11.5636 24.1221H11.5665ZM46.1341 15.0267C45.9578 15.0267 45.7844 14.9584 45.6536 14.8248C41.5366 10.6197 35.8929 8.19446 30.1695 8.17456H30.0842C23.9913 8.17456 18.5494 10.4463 14.3443 14.7509C14.0827 15.0181 13.6534 15.0181 13.389 14.7622C13.1217 14.5007 13.116 14.0742 13.3776 13.8069C17.8414 9.23792 23.616 6.82404 30.0842 6.82404H30.1752C36.254 6.84394 42.2474 9.41419 46.6174 13.878C46.879 14.1453 46.8733 14.5718 46.6089 14.8333C46.4753 14.9641 46.3047 15.0267 46.1369 15.0267H46.1341ZM58.1267 58.8005H50.6263V57.45H57.4529V50.6235H58.8034V58.1239C58.8034 58.4963 58.4992 58.7977 58.1267 58.7977V58.8005ZM9.37439 58.8005H1.87403C1.50157 58.8005 1.2002 58.4992 1.2002 58.1267V50.6263H2.55071V57.4529H9.37723V58.8034L9.37439 58.8005ZM58.8005 9.37439H57.45V2.55071H50.6235V1.2002H58.1239C58.4963 1.2002 58.7977 1.50157 58.7977 1.87403V9.37439H58.8005ZM2.55071 9.37439H1.2002V1.87403C1.2002 1.50157 1.50157 1.2002 1.87403 1.2002H9.37439V2.55071H2.55071V9.37723V9.37439Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_307_90">
                                                <rect width="60" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="mt-10 hh5">Consistent Brand Identity</div>
                                    <p>We ensure all materials follow a cohesive visual and tonal brand language.</p>
                                </div>
                            </div>
                            <div className='xl:w-1/3 px-3'>
                                <div className='card '>
                                    <svg width="62" height="60" viewBox="0 0 62 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_307_87)">
                                            <path d="M55.6339 16.6667H52.5893V14.7222C52.5893 11.2 49.7329 8.33333 46.2232 8.33333H43.1786V6.38889C43.1786 2.86667 40.3221 0 36.8125 0H6.36607C2.85643 0 0 2.86667 0 6.38889V36.9444C0 40.4667 2.85643 43.3333 6.36607 43.3333H9.41071V45.2778C9.41071 48.8 12.2671 51.6667 15.7768 51.6667H18.8214V53.6111C18.8214 57.1333 21.6779 60 25.1875 60H55.6339C59.1436 60 62 57.1333 62 53.6111V23.0556C62 19.5333 59.1436 16.6667 55.6339 16.6667ZM6.36607 41.6667C3.77259 41.6667 1.66071 39.5472 1.66071 36.9444V6.38889C1.66071 3.78611 3.77259 1.66667 6.36607 1.66667H36.8125C39.406 1.66667 41.5179 3.78611 41.5179 6.38889V8.33333H15.7768C12.2671 8.33333 9.41071 11.2 9.41071 14.7222V41.6667H6.36607ZM15.7768 50C13.1833 50 11.0714 47.8806 11.0714 45.2778V14.7222C11.0714 12.1194 13.1833 10 15.7768 10H46.2232C48.8167 10 50.9286 12.1194 50.9286 14.7222V16.6667H25.1875C21.6779 16.6667 18.8214 19.5333 18.8214 23.0556V50H15.7768ZM60.3393 53.6111C60.3393 56.2139 58.2274 58.3333 55.6339 58.3333H25.1875C22.594 58.3333 20.4821 56.2139 20.4821 53.6111V23.0556C20.4821 20.4528 22.594 18.3333 25.1875 18.3333H55.6339C58.2274 18.3333 60.3393 20.4528 60.3393 23.0556V53.6111Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_307_87">
                                                <rect width="62" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="mt-10 hh5">Multi-Channel Expertise</div>
                                    <p>From digital platforms to sales presentations, we understand how collateral works across channels.</p>
                                </div>
                            </div>
                        </div>

                        <div className=' flex flex-wrap  -mx-3 mt-6'>
                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-10 md:mb-0'>
                                    <svg width="57" height="60" viewBox="0 0 57 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_308_102)">
                                            <path d="M15.331 30.8532C6.88645 30.8532 0.00940469 23.9396 1.83707e-05 15.4455C-0.00623918 11.3307 1.58631 7.45829 4.48355 4.53668C7.3808 1.61507 11.2229 0.00629657 15.3122 0C23.7756 0 30.6526 6.91363 30.662 15.4077C30.6714 23.9144 23.8037 30.8437 15.3498 30.8532H15.331ZM15.3154 2.05898C7.99091 2.06842 2.03685 8.0722 2.04624 15.4423C2.05562 22.8062 8.01594 28.7942 15.331 28.7942C22.6742 28.7848 28.6252 22.781 28.6158 15.4109C28.6064 8.04701 22.6461 2.05898 15.331 2.05898H15.3154Z" fill="#DC0000" />
                                            <path d="M21.4004 56.8297C11.2287 56.8297 2.95312 48.5025 2.95312 38.2674C2.95312 37.9841 3.10331 37.7227 3.35048 37.5811C3.59765 37.4426 3.89801 37.4457 4.13893 37.5905L8.55676 40.2571C8.92595 40.4806 9.04798 40.9655 8.82583 41.337C8.60369 41.7085 8.12499 41.8313 7.75266 41.6077L4.58009 39.6936C5.30283 48.3954 12.5741 55.2587 21.4066 55.2587C21.8384 55.2587 22.1888 55.6113 22.1888 56.0458C22.1888 56.4802 21.8384 56.8328 21.4066 56.8328L21.4004 56.8297Z" fill="#DC0000" />
                                            <path d="M54.2084 23.8166C54.0676 23.8166 53.9299 23.7788 53.8048 23.7033L49.387 21.0367C49.0178 20.8131 48.8957 20.3283 49.1179 19.9568C49.34 19.5853 49.8187 19.4625 50.191 19.686L53.3636 21.6002C52.6409 12.8983 45.3696 6.03508 36.5371 6.03508C36.1053 6.03508 35.7549 5.68247 35.7549 5.24801C35.7549 4.81355 36.1053 4.46094 36.5371 4.46094C46.7087 4.46094 54.9843 12.7881 54.9843 23.0232C54.9843 23.3066 54.8341 23.5679 54.587 23.7095C54.4681 23.7788 54.3335 23.8103 54.2021 23.8103L54.2084 23.8166Z" fill="#DC0000" />
                                            <path d="M41.6689 59.9997C33.2149 59.9997 26.3379 53.0797 26.3379 44.5731C26.3379 36.0664 33.2149 29.1465 41.6689 29.1465C50.1228 29.1465 56.9999 36.0664 56.9999 44.5731C56.9999 53.0797 50.1228 59.9997 41.6689 59.9997ZM41.6689 31.2023C34.3444 31.2023 28.3841 37.1998 28.3841 44.5699C28.3841 51.9401 34.3444 57.9375 41.6689 57.9375C48.9933 57.9375 54.9537 51.9401 54.9537 44.5699C54.9537 37.1998 48.9933 31.2023 41.6689 31.2023Z" fill="#DC0000" />
                                            <path d="M44.6817 41.1922C44.6066 40.5342 44.3031 40.0242 43.7681 39.659C43.2331 39.2938 42.5604 39.1144 41.75 39.1144C41.1681 39.1144 40.6675 39.2057 40.2419 39.3883C39.8164 39.5709 39.491 39.8227 39.2564 40.1407C39.0249 40.4587 38.906 40.8176 38.906 41.2237C38.906 41.5637 38.9842 41.8534 39.1437 42.0989C39.3033 42.3445 39.5129 42.5491 39.7726 42.716C40.0323 42.8797 40.3139 43.0182 40.6111 43.1253C40.9115 43.2355 41.1994 43.3236 41.4747 43.3929L42.8576 43.7549C43.3081 43.8651 43.7712 44.0162 44.2468 44.2083C44.7224 44.3972 45.1604 44.649 45.5671 44.9607C45.9739 45.2724 46.3024 45.6565 46.5527 46.1161C46.803 46.5758 46.9281 47.1236 46.9281 47.7658C46.9281 48.5718 46.7216 49.2896 46.3086 49.9161C45.8956 50.5426 45.298 51.0369 44.519 51.399C43.7368 51.761 42.795 51.9405 41.6874 51.9405C40.5799 51.9405 39.7101 51.7705 38.9372 51.4336C38.1644 51.0936 37.5575 50.615 37.1194 49.9917C36.6814 49.3683 36.4405 48.6285 36.3936 47.769H38.5368C38.5774 48.2822 38.7464 48.7103 39.0374 49.0535C39.3315 49.3935 39.7069 49.6454 40.1637 49.8122C40.6237 49.9759 41.1243 50.0609 41.6749 50.0609C42.2788 50.0609 42.8169 49.9633 43.2894 49.7713C43.7618 49.5793 44.1341 49.3085 44.4063 48.9653C44.6785 48.619 44.8131 48.2161 44.8131 47.7501C44.8131 47.3282 44.6942 46.9819 44.4564 46.7143C44.2186 46.4467 43.8995 46.2232 43.4959 46.0469C43.0923 45.8706 42.6386 45.7163 42.1317 45.5809L40.4578 45.1213C39.3252 44.8096 38.4273 44.3531 37.7671 43.7518C37.1069 43.1505 36.7753 42.3508 36.7753 41.3591C36.7753 40.5374 36.9974 39.8227 37.4386 39.2088C37.8797 38.5949 38.4804 38.1195 39.2345 37.7795C39.9916 37.4395 40.8427 37.2695 41.7907 37.2695C42.7387 37.2695 43.596 37.4395 44.3313 37.7763C45.0665 38.1164 45.6453 38.5792 46.0709 39.171C46.4932 39.7629 46.7154 40.4398 46.7342 41.2048H44.6754L44.6817 41.1922ZM41.1368 53.4737V35.667H42.2694V53.4737H41.1368Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_308_102">
                                                <rect width="57" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>



                                    <div className="mt-10 hh5">Conversion-Focused Design</div>
                                    <p>Our designs are crafted to guide action and improve campaign performance.</p>
                                </div>
                            </div>

                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-10 md:mb-0'>
                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_308_111)">
                                            <path d="M19.6556 60C19.3308 60 19.1639 59.9822 19.0804 59.9674C18.6096 59.8815 16.485 58.4509 8.85348 43.6353C4.48795 35.1553 0.614095 26.7167 0.134334 25.1676C-0.136836 24.2909 0.0121582 23.3667 0.548538 22.6292C3.97243 17.899 28.6518 0 32.7045 0H32.7551C35.8781 0.133287 49.967 13.4739 55.3278 19.3059C60.0718 24.4656 60.0211 25.529 59.9973 26.0384C59.8483 29.1514 48.8912 52.5655 45.9709 54.864C43.152 57.0854 24.1075 60 19.6556 60ZM39.5254 46.9408C39.3228 47.0652 39.1321 47.1481 38.9503 47.1955C35.4281 48.0989 29.1823 49.183 24.8316 49.7902C24.7601 49.7991 24.6916 49.802 24.623 49.805L24.4383 49.8109L24.3548 49.9798L20.6657 58.1725L21.1664 58.134C25.8627 57.7667 39.585 55.5541 43.7897 53.9488L44.1234 53.8214L39.7817 46.7838L39.5284 46.9408H39.5254ZM2.34541 25.8962C4.95579 32.6583 15.153 52.1983 18.6335 57.1003L18.9344 57.5268L22.8053 48.9312L22.7099 48.7772L22.6772 48.7357C19.6854 43.5879 14.9205 34.4207 11.8453 27.8867L11.7857 27.7593L2.14278 25.366L2.34839 25.8962H2.34541ZM48.629 29.104L48.5664 29.2462C46.7159 33.5291 43.4261 40.4808 40.9707 44.9326L40.8873 45.0837L45.5329 52.6129L45.7921 52.2279C48.6797 47.9153 55.9267 32.996 57.7206 27.6675L57.8845 27.1788L48.626 29.107L48.629 29.104ZM25.2995 47.8738L25.8388 47.7938C29.8378 47.2015 35.3 46.2388 38.4855 45.4243L38.8758 45.3236L31.6913 33.6772L25.2995 47.8738ZM14.3573 28.8967C17.1137 34.5984 20.7641 41.6182 23.443 46.3603L23.732 46.8727L30.2759 32.3444L14.0862 28.328L14.3603 28.8967H14.3573ZM33.0353 32.3503L39.7847 43.2887L40.029 42.8296C41.8676 39.3671 44.2843 34.3674 46.1885 30.0933L46.4239 29.5661L33.0382 32.3533L33.0353 32.3503ZM32.5138 30.585L47.2165 27.5253L46.8619 27.1432C43.5155 23.5267 37.7286 17.9997 33.4048 14.2884L32.928 13.8796L32.5138 30.5879V30.585ZM30.6186 13.8589C25.5051 17.1319 18.4636 22.1968 13.8746 25.8992L13.4127 26.2724L30.6692 30.5524L31.0894 13.5538L30.6156 13.856L30.6186 13.8589ZM32.9846 11.5901L33.1157 11.6819C33.1515 11.7056 33.1872 11.7263 33.226 11.747C33.2409 11.753 33.2528 11.7589 33.2677 11.7707C37.8835 15.5916 44.7253 22.0842 48.5187 26.2428C48.6797 26.4205 48.8078 26.6367 48.9151 26.9211L49.0045 27.158L57.9203 25.3009L57.6849 24.9395C54.7497 20.3989 38.3543 4.92274 33.6521 2.257L33.22 2.01116L32.9816 11.593L32.9846 11.5901ZM30.9315 2.4436C25.1713 5.27225 6.83312 18.1152 2.50334 23.1268L2.18747 23.4911L11.5592 25.8163L11.6665 25.603C11.8214 25.292 11.9883 25.0669 12.1999 24.8951C17.1703 20.8313 25.5051 14.8689 30.7825 11.6019C30.7974 11.593 30.8242 11.5841 30.857 11.5723C30.9017 11.5575 30.9434 11.5427 30.9851 11.5219L31.146 11.442L31.3755 2.2333L30.9344 2.44952L30.9315 2.4436Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_308_111">
                                                <rect width="60" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <div className="mt-10 hh5">Creative + Data-Driven Approach</div>
                                    <p>We balance creativity with insights to deliver measurable results.</p>
                                </div>
                            </div>

                            <div className='xl:w-1/3 px-3'>
                                <div className='card'>
                                    <svg width="58" height="60" viewBox="0 0 58 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_301_1832)">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M28.9918 60C27.0845 60 25.4306 58.6205 25.065 56.7237C24.6952 54.8269 25.7132 52.9174 27.4792 52.1856C27.9654 51.9837 28.4765 51.8828 28.9959 51.8828C30.3505 51.8828 31.6013 52.5641 32.3451 53.7081L33.1637 54.9657L34.6388 54.7848C44.0465 53.624 48.0065 49.6117 49.6686 46.4447L50.8404 44.2156L48.5924 43.1179C46.3319 42.016 44.8651 39.6607 44.8568 37.1246V32.595C44.8568 29.8864 46.4607 27.4681 48.9415 26.4419L50.6119 25.7479L50.4166 23.931C49.8556 18.699 46.6519 1.62765 29.0001 1.62765C11.3483 1.62765 8.11541 18.699 7.55029 23.931L7.35499 25.7521L9.02959 26.4419C11.5145 27.4681 13.1309 29.8864 13.1434 32.6034V37.133C13.1434 40.8005 10.1931 43.7866 6.56963 43.7866C2.94619 43.7866 6.82866e-05 40.8005 6.82866e-05 37.133V32.595C-0.0123977 29.8444 1.68297 27.3419 4.21772 26.3704L5.60975 25.8363L5.75519 24.3348C6.14579 20.272 9.10854 0 29.0001 0C48.8916 0 51.8502 20.272 52.2449 24.3348L52.3904 25.8363L53.7824 26.3704C56.3172 27.3461 58.0125 29.8402 58.0001 32.5866V37.1372C58.0375 40.0771 56.2174 42.6511 53.4749 43.5511L52.3197 43.9296L51.9375 45.0988C50.7573 48.7074 46.9178 54.9783 34.4311 56.4209L33.1346 56.5723L32.5529 57.7541C31.8756 59.1336 30.5126 59.9958 28.9918 60.0042V60ZM51.4264 27.5732C48.6921 27.5732 46.4649 29.8276 46.4649 32.595V37.133C46.4649 39.9005 48.6921 42.1548 51.4264 42.1548C54.1606 42.1548 56.3878 39.9005 56.3878 37.133V32.595C56.3878 29.8276 54.1606 27.5732 51.4264 27.5732ZM6.57379 27.5732C5.70533 27.5732 4.84518 27.8046 4.09306 28.2462C2.5639 29.1378 1.61233 30.8075 1.61233 32.595V37.133C1.61233 39.9005 3.83959 42.1548 6.57379 42.1548C9.30799 42.1548 11.5352 39.9005 11.5352 37.133V32.595C11.5352 30.8075 10.5837 29.1378 9.05452 28.2462C8.3024 27.8046 7.44225 27.5732 6.57379 27.5732Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_301_1832">
                                                <rect width="58" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="mt-10 hh5">Reliable Turnaround & Support</div>
                                    <p>Timely delivery, clear communication, and ongoing support when you need it.</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>




            </section>

            <GC_FAQ faq={faq} />

            <section className='page-services cta-1'>
                <div className='container'>
                    <div className="w-full relative  xl:hidden mb-10 px-5 " data-aos="fade-up">
                        <img className="" src="/assets/img/services/marketing-collateral/cta.webp" alt="Marketing Collateral" width="100%" data-aos="fade-up" />
                    </div>
                    <div className='flex flex-wrap items-center -mx-20'>
                        <div className='xl:w-1/2 px-20 content-wrapper '>
                            <div className="hh2" >Let’s Create Marketing Collateral <span className='text-primary'> That Works</span></div>
                            <p>Whether you’re launching a campaign or strengthening brand consistency, we’re ready to help you stand out.</p>
                            <button className="mt-10" data-aos="fade-up" data-aos-delay="200" onClick={openCalendly}> <div>TALK TO OUR EXPERTS<i></i></div></button>
                        </div>
                        <div className='xl:w-1/2 px-20 mt-15 md:mt-0 text-center content-wrapper hidden xl:flex'>
                            <img src="/assets/img/services/marketing-collateral/cta.webp"  width="664px" height="675px" alt="Let’s Create Marketing Collateral That Works" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MarketingCollateral
